import React, { useCallback, useEffect, useState } from "react";
import { toJS } from "mobx";
import StakingWrapper from "../services/staking.wrapper";
import { PoolsContext } from "config";
import appStore from "store/app.store";
import { useAccount } from "wagmi";
import { useEthersAdapter } from "@airdao/ui-library";
import { providers } from "ethers";

const readProvider = new providers.JsonRpcProvider(
  process.env.REACT_APP_RPC_URL
);

function PoolsContextProvider(props) {
  const [pools, setPools] = useState([]);

  const { address: account } = useAccount();
  const { provider } = useEthersAdapter();

  const getPools = useCallback(async () => {
    const poolsData = await StakingWrapper.getPoolsData(provider);

    await appStore.updatePoolData(poolsData);
    if (appStore.poolsData && appStore.poolsData.length > 0)
      setPools(toJS(appStore.poolsData));
  }, [provider, account]);

  useEffect(() => {
    getPools();

    readProvider.on("block", getPools);
    return () => {
      readProvider.removeListener("block", getPools);
    };
  }, [getPools]);

  return <PoolsContext.Provider value={pools} {...props} />;
}

export default PoolsContextProvider;
